import React, { useState, useEffect } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FaStar, FaRegStar } from "react-icons/fa";
import { PiUsers } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import { MdOutlineAccessTime } from "react-icons/md";
import { useNavigate, NavLink, Link } from "react-router-dom";
import { TbMoneybag } from "react-icons/tb";
import { Nav, Button, Container, Col, Form, Row, Dropdown, FormControl } from "react-bootstrap";
import Footer from "../Footer/Footer";

const ServicesList = [
  {
    id: 1,
    name: "Veritis Development Agency",
    image:
      "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
    staff: "10 - 49",
    location: "New York, USA",
    budget: "$25,000+",
    hourrate: "$50 - $99/hr",
    rating: 4.5,
    review: 26,
    vendors: [
      { name: "Vendor A", rating: 5, reviews: 12 },
      { name: "Vendor B", rating: 4, reviews: 8 },
    ],
    description:
      "Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective major service solutions.",
    services: [
      "Website Development",
      "App Development",
      "Development",
      "AWS",
      "Azure",
      "Design",
    ],
  },

  {
    id: 2,
    name: "Aevitas Development Agency",
    image:
      "https://img.freepik.com/free-vector/colorful-letter-gradient-logo-design_474888-2309.jpg",
    staff: "10 - 49",
    location: "New York, USA",
    budget: "$25,000+",
    hourrate: "$50 - $99/hr",
    rating: 4.9,
    review: 262,
    vendors: [
      { name: "Vendor A", rating: 5, reviews: 12 },
      { name: "Vendor B", rating: 4, reviews: 8 },
    ],
    description:
      "Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective major service solutions.",
    services: [
      "Website Development",
      "App Development",
      "Development",
      "AWS",
      "Azure",
      "Design",
    ],
  },

  {
    id: 3,
    name: "Oractel Data Solutions",
    image: "https://cryptologos.cc/logos/arbitrum-arb-logo.png",
    staff: "10 - 49",
    location: "New York, USA",
    budget: "$25,000+",
    hourrate: "$50 - $99/hr",
    rating: 4.2,
    review: 32,
    vendors: [
      { name: "Vendor A", rating: 5, reviews: 12 },
      { name: "Vendor B", rating: 4, reviews: 8 },
    ],
    description:
      "Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective major service solutions.",
    services: [
      "Website Development",
      "App Development",
      "Development",
      "AWS",
      "Azure",
      "Design",
    ],
  },

  {
    id: 4,
    name: "ITR Mobile Solutions",
    image: "https://www.logoai.com/oss/icons/2021/10/27/MuCSnBxFpOQg2Kl.png",
    staff: "10 - 49",
    location: "New York, USA",
    budget: "$25,000+",
    hourrate: "$50 - $99/hr",
    rating: 3.9,
    review: 125,
    vendors: [
      { name: "Vendor A", rating: 5, reviews: 12 },
      { name: "Vendor B", rating: 4, reviews: 8 },
    ],
    description:
      "Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective major service solutions.",
    services: [
      "Website Development",
      "App Development",
      "Development",
      "AWS",
      "Azure",
      "Design",
    ],
  },

  {
    id: 5,
    name: "Gtech Corporation",
    image: "https://www.logoai.com/oss/icons/2021/10/27/VgRTHEL8YOYKnCn.png",
    staff: "10 - 49",
    location: "New York, USA",
    budget: "$25,000+",
    hourrate: "$50 - $99/hr",
    rating: 4.1,
    review: 200,
    vendors: [
      { name: "Vendor A", rating: 5, reviews: 12 },
      { name: "Vendor B", rating: 4, reviews: 8 },
    ],
    description:
      "Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective major service solutions.",
    services: [
      "Website Development",
      "App Development",
      "Development",
      "AWS",
      "Azure",
      "Design",
    ],
  },
];

function ServicesListComponent() {
  const navigate = useNavigate();
  const [bookmarked, setBookmarked] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    projectTitle: "",
    projectDescription: "",
    startDate: "",
    budget: "",
    company: "",
    contactName: "",
    email: "",
    phone: "",
    projectType: "",
  });
  const [errors, setErrors] = useState({});

  const projectTypes = ["Web Development", "Mobile App Development", "SEO", "Graphic Design"];

  const toggleBookmark = () => setBookmarked(!bookmarked);

  const validate = () => {
    let newErrors = {};
    if (!formData.projectType) newErrors.projectType = "Project type is required";
    if (!formData.projectTitle) newErrors.projectTitle = "Project title is required";
    if (!formData.projectDescription) newErrors.projectDescription = "Project description is required";
    if (!formData.startDate) newErrors.startDate = "Start date is required";
    if (!formData.budget) newErrors.budget = "Budget is required";
    if (!formData.company) newErrors.company = "Company is required";
    if (!formData.contactName) newErrors.contactName = "Contact name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Invalid email format";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => {
    if (step < 3 && !validate()) return;
    setStep((prevStep) => prevStep + 1);
  };

  const prevStep = () => setStep(step - 1);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [searchTerm, setSearchTerm] = useState({
    location: "",
    service: "",
    employees: "",
    reviews: "",
  });

  const [budgetRange, setBudgetRange] = useState([0, 1000000]);
  const [hourlyRateRange, setHourlyRateRange] = useState([0, 500]);

  const filterOptions = {
    service: ["Website Development", "App Development", "AWS", "E Commerce"],
    employees: ["1 - 10", "11 - 50", "51+"],
    reviews: ["1+", "2+", "3+", "4+"],
  };

  const handleSearch = (e, type) => {
    setSearchTerm({ ...searchTerm, [type]: e.target.value });
  };

  const handleHourlyRateChange = (e) => {
    setHourlyRateRange([hourlyRateRange[0], parseInt(e.target.value, 10)]);
  };

  const popover = (
    <Popover id="popover-basic" style={{ maxWidth: "300px", width: "300px" }}>
      <Popover.Header as="h3">Vendor Reviews</Popover.Header>
      <Popover.Body className="m-0 p-0">
        {/* ... (Your existing popover content remains unchanged) */}
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      <div className="sub-header sub-search py-3 bg-light border-bottom border-top">
        <Container>
          <Row className="align-items-start">
            <Col md={12}>
              <Form className="d-flex flex-md-row flex-column gap-2 gap-md-0">
                <Form.Control
                  type="search"
                  placeholder="e.g. App Development, UX Design, IT Services..."
                  className="me-md-4 px-4 rounded-5 w-100 w-md-auto"
                  aria-label="Search"
                  value="Website Development Companies"
                />
                <Form.Control
                  type="text"
                  placeholder="Enter location"
                  className="me-md-4 px-4 rounded-5 w-100 w-md-auto"
                  aria-label="Location"
                />
                <Button variant="primary" className="px-4 rounded-5 w-25 w-md-auto">
                  Search
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>

      <section className="page-header bg-skyblue py-2">
        <div className="container py-4 pb-2">
          <div className="row page-introduction">
            <div className="col-12">
              <div className="d-flex align-items-start justify-content-between flex-md-row flex-column">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item small">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item small active" aria-current="page">
                      Website Development Companies
                    </li>
                  </ol>
                </nav>
                <span>
                  <strong>18530</strong> Companies Listed
                </span>
              </div>
              <h3 className="mt-2">Top Website Development Companies</h3>
              <p className="mini-content text-muted">
                We have created a global list of top mobile app development companies to help you hire the best app developers.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col-12">
            <div className="card rounded-3 p-2 bg-white shadow-sm">
              <div className="card-body">
                <div className="d-flex search-filter flex-wrap gap-4 flex-md-row flex-column">
                  {Object.keys(filterOptions).map((key) => (
                    <Dropdown key={key}>
                      <Dropdown.Toggle as="div" className="form-select w-auto pe-5 w-100 w-md-auto">
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="px-2" style={{ maxHeight: "250px", overflowY: "auto" }}>
                        {key !== "employees" && key !== "reviews" && (
                          <FormControl
                            type="text"
                            placeholder="Search..."
                            className="mx-2 p-1 px-3 my-2 mb-3 w-auto form-control"
                            onChange={(e) => handleSearch(e, key)}
                          />
                        )}
                        {filterOptions[key]
                          .filter((option) => option.toLowerCase().includes(searchTerm[key].toLowerCase()))
                          .map((option, index) => (
                            <Form.Check
                              className="mx-2 mt-2 small"
                              key={index}
                              type="checkbox"
                              id={`${key}-${index}`}
                              label={option}
                            />
                          ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ))}
                  <Dropdown>
                    <Dropdown.Toggle
                      className="form-select range-slider bg-white text-dark w-auto pe-5 w-100 w-md-auto"
                      style={{ minWidth: "240px", maxWidth: "240px", whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      Hourly Rate: ${hourlyRateRange[0]} - ${hourlyRateRange[1]}/hr
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-3">
                      <Form.Label className="small">Set Hourly Rate</Form.Label>
                      <Form.Range
                        min={0}
                        max={500}
                        step={10}
                        value={hourlyRateRange[1]}
                        onChange={handleHourlyRateChange}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="py-4 mt-2 d-flex justify-content-between align-items-center flex-md-row flex-column gap-2">
          <h5>Here are the 214 Best Web Development Companies</h5>
          <div className="d-flex align-items-center">
            <label className="me-2 fw-regular text-muted">Sort By:</label>
            <select className="form-select w-auto pe-5 w-100 w-md-auto">
              <option value="sponsored">Sponsored</option>
              <option value="high-rating">High Rating</option>
            </select>
          </div>
        </div>

        <div className="row">
          {ServicesList.map((profile) => (
            <div className="col-lg-12 col-sm-12 mb-4" key={profile.id}>
              <div className="d-lg-flex card rounded-4 align-items-stretch p-4">
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-md-between justify-content-sm-end flex-column flex-md-row">
                    <div className="d-flex align-items-center mb-3 flex-md-row flex-column">
                      <img
                        src={profile.image}
                        className="img-thumbnail rounded-3 border-1 me-4 mb-3 mb-md-0"
                        alt={profile.name}
                        style={{ maxWidth: "50px" }}
                      />
                      <div>
                        <h5 className="card-title m-0 p-0">
                          <NavLink
                            as={Link}
                            to="/CompnayProfileDetailed"
                            className="p-0 m-0 text-decoration-none text-dark"
                          >
                            {profile.name}
                          </NavLink>{" "}
                          <span className="ms-3 small verify py-0 rounded-4 fs-6 p-2 text-success">
                            <i className="bx text-success bxs-check-circle"></i> Verified
                          </span>
                        </h5>
                        <span className="card-text rating">
                          <strong className="me-2">{profile.rating}</strong>
                          {[...Array(5)].map((_, index) =>
                            index < profile.rating ? (
                              <FaStar key={index} className="text-warning" />
                            ) : (
                              <FaRegStar key={index} className="text-warning" />
                            )
                          )}
                          <span className="ms-2 small">(26 Reviews)</span>
                        </span>
                      </div>
                    </div>

                    <div className="mb-2">


<button
  className="btn fs-2 p-0 m-0 pt-2 me-3 icon-clr"
  onClick={toggleBookmark}
>
  <i class="bx bxs-check-shield"></i>
</button>


<Button className="btn btn-md btn-primary btn btn-primary"
                        onClick={() => setShowCanvas(true)} >
                        Hire Us
</Button>
</div>

                  </div>






                  <div className="row border-top pt-4 align-items-start">
  {/* First Column */}
  <div className="col-md-3 mt-3">
    <div className="d-flex flex-wrap">
      <p className="fw-500 pe-2 small w-50">
        <TbMoneybag className="me-1 text-primary fs-5" /> {profile.budget}
      </p>
      <p className="fw-500 pe-2 small w-50">
        <MdOutlineAccessTime className="me-1 text-primary fs-5" /> {profile.hourrate}
      </p>
      <p className="fw-500 pe-2 small w-50">
        <PiUsers className="me-1 text-primary fs-5" /> {profile.staff}
      </p>
      <p className="fw-500 pe-2 small w-50">
        <CiLocationOn className="me-1 text-primary fs-5" /> {profile.location}
      </p>
    </div>
  </div>

  {/* Second Column */}
  <div className="col-md-6 px-3 px-md-4 pb-2 pb-md-0">
    <p className="text-muted">
      {profile.description}...
      <NavLink to="/CompnayProfileDetailed" className="btn p-0 btn-link text-primary">
        View Profile
      </NavLink>
    </p>
  </div>

  {/* Third Column */}
  <div className="col-md-3 px-3 px-md-4 pb-3 pb-md-0 text-center text-md-start">
    <button className="btn w-100 mb-2 btn-sm btn-outline-primary text-primary">
      Visit Website <i className="bx bx-link-external"></i>
    </button>
    <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
      <button className="btn w-100 btn-sm btn-outline-primary text-primary">
        Expertise Reviews <FaStar className="text-warning" />
      </button>
    </OverlayTrigger>
  </div>
</div>





                </div>
              </div>
            </div>
          ))}

          <div className="d-flex justify-content-between align-items-center p-3 mb-5 flex-md-row flex-column gap-2">
            <div className="text-muted">Showing 10 of 215</div>
            <nav aria-label="Page navigation">
              <ul className="pagination mb-0">
                <li className="page-item disabled">
                  <button className="page-link">Previous</button>
                </li>
                <li className="page-item active">
                  <button className="page-link">1</button>
                </li>
                <li className="page-item">
                  <button className="page-link">2</button>
                </li>
                <li className="page-item">
                  <button className="page-link">3</button>
                </li>
                <li className="page-item">
                  <button className="page-link">Next</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <div
        className={`offcanvas offcanvas-end ${showCanvas ? "show" : ""}`}
        tabIndex="-1"
        style={{ visibility: showCanvas ? "visible" : "hidden", width: "600px" }}
      >
        <div className="offcanvas-header px-5 pt-4">
          <h3 className="offcanvas-title">Hire Us</h3>
          <button type="button" className="btn-close" onClick={() => setShowCanvas(false)}></button>
        </div>
        <div className="offcanvas-body px-5">
          <div className="d-flex align-items-center p-3 border bg-light rounded-4 flex-md-row flex-column gap-3">
            <img
              src="https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4"
              alt="Veritis Development Agency"
              className="img-thumbnail rounded-3 border me-md-3"
              style={{ maxWidth: "80px" }}
            />
            <div>
              <h5 className="card-title pb-2" style={{ cursor: "pointer" }}>
                Veritis Development Agency
              </h5>
              <span className="card-text">
                <strong className="me-2">4.5</strong>
                {[...Array(5)].map((_, index) =>
                  index < 5 ? <FaStar key={index} className="text-warning" /> : <FaRegStar key={index} className="text-warning" />
                )}
                <span className="ms-2 small">(26 Reviews)</span>
              </span>
            </div>
          </div>

          <div className="pt-2">
            <div className="d-flex align-items-center justify-content-between mb-4 position-relative border rounded-3 p-3 mt-4 flex-md-row flex-column gap-3">
              {["Project Info", "Contact Info", "Preview"].map((stepTitle, index) => (
                <div
                  key={index}
                  className="position-relative d-flex flex-column align-items-center flex-grow-1"
                >
                  {index !== 0 && (
                    <div
                      className="position-absolute top-50 start-0 w-100 border-bottom border-dashed border-secondary d-md-block d-none"
                      style={{ left: "50%", transform: "translateX(-50%)", zIndex: -1 }}
                    ></div>
                  )}
                  <div
                    className={`badge d-flex fs-6 align-items-center p-2 px-3 ${
                      step > index + 1
                        ? "bg-success text-white"
                        : step === index + 1
                        ? "border-primary bg-white text-primary"
                        : "bg-light text-dark"
                    }`}
                  >
                    {stepTitle}
                  </div>
                </div>
              ))}
            </div>

            {step === 1 && (
              <>
                <h5 className="py-3">Project Information</h5>
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label>Project Type</Form.Label>
                    <Form.Select name="projectType" value={formData.projectType} onChange={handleChange}>
                      <option value="">Select Project Type</option>
                      {projectTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </Form.Select>
                    {errors.projectType && <div className="text-danger">{errors.projectType}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Project Title</Form.Label>
                    <Form.Control type="text" name="projectTitle" value={formData.projectTitle} onChange={handleChange} />
                    {errors.projectTitle && <div className="text-danger">{errors.projectTitle}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Project Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="projectDescription"
                      value={formData.projectDescription}
                      onChange={handleChange}
                    />
                    {errors.projectDescription && <div className="text-danger">{errors.projectDescription}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Start From</Form.Label>
                    <Form.Select name="startDate" value={formData.startDate} onChange={handleChange}>
                      <option value="">Select Start Time</option>
                      <option value="immediately">Immediately</option>
                      <option value="lessThan15">Less than 15 Days</option>
                      <option value="15to30">15-30 Days</option>
                      <option value="30to60">30-60 Days</option>
                    </Form.Select>
                    {errors.startDate && <div className="text-danger">{errors.startDate}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Budget</Form.Label>
                    <Form.Select name="budget" value={formData.budget} onChange={handleChange}>
                      <option value="">Select Budget</option>
                      <option value="$10,000-20,000">$10,000-20,000</option>
                      <option value="$20,000-40,000">$20,000-40,000</option>
                      <option value="$40,000-60,000">$40,000-60,000</option>
                    </Form.Select>
                    {errors.budget && <div className="text-danger">{errors.budget}</div>}
                  </Form.Group>
                  <Button className="btn btn-primary mt-2 w-100 w-md-auto" onClick={nextStep}>
                    Continue
                  </Button>
                </Form>
              </>
            )}

            {step === 2 && (
              <>
                <h5 className="py-3">Your Information</h5>
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control type="text" name="company" value={formData.company} onChange={handleChange} />
                    {errors.company && <div className="text-danger">{errors.company}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Your Full Name</Form.Label>
                    <Form.Control type="text" name="contactName" value={formData.contactName} onChange={handleChange} />
                    {errors.contactName && <div className="text-danger">{errors.contactName}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
                    {errors.email && <div className="text-danger">{errors.email}</div>}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control type="text" name="phone" value={formData.phone} onChange={handleChange} />
                    {errors.phone && <div className="text-danger">{errors.phone}</div>}
                  </Form.Group>
                  <div className="d-flex flex-column flex-md-row gap-2">
                    <button className="btn btn-outline-primary text-primary me-md-3 w-100 w-md-auto" onClick={prevStep}>
                      Back
                    </button>
                    <button className="btn btn-primary w-100 w-md-auto" onClick={nextStep}>
                      Continue
                    </button>
                  </div>
                </Form>
              </>
            )}

            {step === 3 && (
              <>
                <h5 className="py-3">Review & Submit</h5>
                {Object.entries(formData).map(([key, value]) => (
                  <p key={key} className="pt-2 pb-3 m-0 mb-2 border-bottom">
                    <span className="text-muted small d-block">
                      {key.replace(/([A-Z])/g, " $1").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}:
                    </span>
                    <span className="d-block fs-6 pt-2">{value}</span>
                  </p>
                ))}
                <div className="d-flex flex-column flex-md-row gap-2">
                  <button className="btn btn-outline-primary mt-3 text-primary me-md-3 w-100 w-md-auto" onClick={prevStep}>
                    Back
                  </button>
                  <button className="btn btn-primary mt-3 w-100 w-md-auto" onClick={nextStep}>
                    Submit
                  </button>
                </div>
              </>
            )}

            {step === 4 && (
              <>
                <div className="text-center border rounded-4 p-5">
                  <h3 className="mb-4">Congratulations! 🎉</h3>
                  <p>Your request has been successfully submitted as a proposal.</p>
                  <div className="d-flex flex-column flex-md-row gap-2">
                    <button className="btn btn-outline-primary mt-3 text-primary me-md-3 w-100 w-md-auto" onClick={() => setShowCanvas(false)}>
                      Close
                    </button>
                    <Button as={Link} to="/noncompanyprofile" className="btn btn-primary mt-3 w-100 w-md-auto">
                      View Proposals
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ServicesListComponent;